<!-- @format -->

@if (infoOnly) {
	<div class="info-container">
		<div class="info-header-container hmf-mb-xs">
			<homefield-icon
				[fill]="iconFillColor"
				[name]="content ? content[accessState]?.icon : ''"></homefield-icon>
			<span class="info-header hmf-ml-xxs">{{
				content ? (isAOS ? getAOSHeaderText() : getHeaderText()) : ''
			}}</span>
		</div>
		<div
			class="info-text"
			[class.aos-info-text-width]="isAOS"
			[class.info-text-width]="!isAOS">
			<span
				[innerHTML]="
					!content
						? ''
						: isAOS
							? content[accessState]?.aosBodyText
							: (content[accessState]?.bodyText | dcsgSanitizeHtml)
				"></span>
		</div>
	</div>
} @else {
	<button
		[class.connect-btn]="onConfirmation"
		id="panel-trigger"
		variant="{{ content?.connectAccButton?.buttonType }}"
		homefield-button
		height="large"
		(click)="openDrawer(); triggerAnalytics()"
		[disabled]="isAOS">
		{{
			buttonText
				? buttonText
				: isAOS
					? content?.connectAccButton?.aosContent
					: content?.connectAccButton?.content
		}}
	</button>

	@if (hasStickyBanner && !isAOS) {
		<shared-component-sticky-banner
			elementToCalculateOffset="#panel-trigger"
			[mobileOnly]="mobileOnlyStickyBanner"
			[mobileHeight]="100">
			<a
				id="sticky-panel-trigger"
				ngProjectAs="customStickyBody"
				class="hmf-mx-s"
				homefield-button
				height="large"
				[variant]="'primary'"
				(click)="openDrawer(); triggerAnalytics()">
				{{ buttonText }}
			</a>
		</shared-component-sticky-banner>
	}
}

<ng-template #drawerContent>
	<div class="hmf-w-100 exclusive-product-panel-content">
		<div class="top-section hmf-align-items-center hmf-position-relative">
			@if (content) {
				<img
					[src]="contentBackground"
					[alt]="content?.headlineText" />
			}
			<div
				class="top-section-content hmf-p-s hmf-display-flex hmf-flex-column hmf-position-absolute hmf-align-items-center">
				@if (content) {
					<img
						loading="lazy"
						[src]="contentLogo"
						[alt]="content?.headlineText || 'Exclusive Product Logo'" />
				}
			</div>
		</div>
		<div
			class="bottom hmf-mx-m hmf-mx-md-l hmf-pt-md-m hmf-pt-s hmf-display-flex hmf-flex-column hmf-align-items-center">
			@for (item of content?.panelContent[ctaType]; track trackByFn($index, item)) {
				<div
					[class.bottom-item-auto-width]="item.buttonType === 'tertiary'"
					[class.bottom-item]="item.buttonType !== 'tertiary'">
					@switch (item.contentType) {
						@case ('button') {
							<a
								hmf-button
								class="hmf-mb-md-m hmf-mb-s hmf-w-100"
								[variant]="item?.buttonType"
								[dataEm]="item?.dataEventName"
								(click)="doAction(item?.linkAction)">
								{{ item?.content }}
							</a>
						}
						@case ('alert') {
							@if (alert) {
								<div class="hmf-mb-m">
									<hmf-alert-banner
										[messageTitle]="alert.messageTitle"
										[messageBody]="alert.messageBody"
										[messageType]="alert.messageType"
										[displayIcon]="alert.displayIcon"></hmf-alert-banner>
								</div>
							}
						}
						@case ('bodyText') {
							<p class="hmf-mb-m-m hmf-mb-s">
								{{ item?.content }}
							</p>
						}
					}
				</div>
			}
		</div>
	</div>
</ng-template>
